"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _CustomIconOrImage = _interopRequireDefault(require("../../shared/CustomIconOrImage"));
var _SliderPicker = require("../SliderPicker/SliderPicker");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledGridRow = (0, _styledComponents.default)(_r10SourceLibrary.GridRow)`
  flex: 1;
`;
const BorderedContainer = _styledComponents.default.div`
  padding: 20px;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 15px;
`;
const StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  display: flex;
  flex: 1;
  min-width: 100%;
  justify-content: center;
  align-items: center;
  margin: auto 0px;
  gap: 10px;
  fieldset {
    flex: 1;
    & span {
      display: inline-block;
    }
  }
`;
const mapProps = function (labels) {
  let idPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return labels.map((entry, index) => {
    return {
      value: entry.value,
      title: entry.label,
      id: `${idPrefix}item-${index}`,
      isDefault: !!entry.isDefault
    };
  });
};
const RangePicker = _ref => {
  let {
    icon,
    src,
    title,
    onChangeValue,
    choices,
    selection,
    idPrefix,
    type = 'default',
    sliderStyle
  } = _ref;
  const ContainerWrapper = sliderStyle.border ? BorderedContainer : _r10SourceLibrary.Container;
  return /*#__PURE__*/_react.default.createElement(StyledGridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(ContainerWrapper, {
    elevation: true
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_CustomIconOrImage.default, {
    name: icon,
    group: "midLight",
    size: 1,
    src: src,
    testId: "slider-icon"
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3,
    dataAttributes: {
      'data-test-id': 'slider-question-title'
    }
  }, title)))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center"
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, {
    col: 10
  }, type === 'sliderPicker' ? /*#__PURE__*/_react.default.createElement(_SliderPicker.SliderPicker, {
    selected: selection,
    label: title,
    onChange: e => {
      onChangeValue(e.target.value);
    },
    items: mapProps(choices, idPrefix),
    sliderAppearance: sliderStyle.appearance
  }) : /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Picker, {
    selected: selection,
    label: title,
    onChange: e => {
      onChangeValue(e.target.value);
    },
    groupName: title,
    items: mapProps(choices, idPrefix),
    columns: {
      sm: 1,
      md: 3,
      lg: 3
    }
  }))))));
};
var _default = RangePicker;
exports.default = _default;